export enum KYC_VALIDATION_STATUS {
	NONE = "NONE",
	SKIPPED = "SKIPPED",
	QUEUED = "QUEUED",
	SUCCESS = "SUCCESS",
	FAILED = "FAILED",
	TIMEOUT = "TIMEOUT",
	PENDING = "PENDING",
}
